import * as Constants from "../common/Constants";

const initialState = {
    currentEmployees: [],
    filteredEmployees: [],
    employee:null,
    isLoading: false,
    isPosting: false,
    isPosted: false,
    isDuplicateCode: false,
    count: 0,
    page: 1,
    pageSize: 10,
    error: null
};

export default function employeeReducer(state = initialState, action) {

    switch (action.type) {
        
        case Constants.REQUEST_ADD_EMPLOYEE:
            var newState = { ...state };
            newState.isPosted = false;
            newState.error = null;
            newState.isPosting = true;
            return newState;

        case Constants.SUCCESS_ADD_EMPLOYEE:
            var newState = { ...state };
            newState.isPosting = false;
            newState.error = null;
            newState.isPosted = true;
            return newState;

        case Constants.FAILED_ADD_EMPLOYEE:
            var newState = { ...state };
            newState.isPosting = false;
            newState.isPosted = false;
            newState.error = action.error;
            return newState;

        case Constants.REQUEST_GET_EMPLOYEES_LIST:
            var newState = { ...state };
            newState.isPosted = false;
            newState.error = null;
            newState.isLoading = true;
            newState.isPosting = false;
            //newState.filteredUsers = action.filteredUsers;
            return newState;

        case Constants.SUCCESS_GET_EMPLOYEES_LIST:
            var newState = { ...state };
            newState.isPosting = false;
            newState.isPosted = false;
            newState.error = null;
            newState.isLoading = false;
            newState.currentEmployees = action.payload.items;
            newState.page = action.payload.page;
            newState.pageSize = action.payload.pageSize;
            newState.count = action.payload.totalCount;
            return newState;

        case Constants.FAILED_GET_EMPLOYEES_LIST:
            var newState = { ...state };
            newState.isPosting = false;
            newState.isPosted = false;
            newState.isLoading = false;
            newState.error = action.error;
            return newState;

        case Constants.REQUEST_GET_SINGLE_EMPLOYEE:
            var newState = { ...state };
            newState.isPosted = false;
            newState.error = null;
            newState.isLoading = true;
            newState.isPosting = false;
            //newState.filteredUsers = action.filteredUsers;
            return newState;

        case Constants.SUCCESS_GET_SINGLE_EMPLOYEE:
            var newState = { ...state };
            newState.isPosting = false;
            newState.isPosted = false;
            newState.error = null;
            newState.isLoading = false;
            newState.employee = action.payload;
            return newState;

        case Constants.FAILED_GET_SINGLE_EMPLOYEE:
            var newState = { ...state };
            newState.isPosting = false;
            newState.isPosted = false;
            newState.isLoading = false;
            newState.error = action.error;
            return newState;

        case Constants.REQUEST_CHECK_DUPLICATE_CODE:
            var newState = { ...state };
            newState.isPosting = false;
            newState.isPosted = false;
            newState.error = null;
            newState.isLoading = true;
            return newState;
       
        case Constants.SUCCESS_CHECK_DUPLICATE_CODE:
            var newState = { ...state };
            newState.isPosting = false;
            newState.isPosted = false;
            newState.error = null;
            newState.isLoading = false;
            newState.isDuplicateCode = action.payload;
            return newState;

        case Constants.ERROR_CHECK_DUPLICATE_CODE:
            var newState = { ...state };
            newState.isPosting = false;
            newState.isPosted = false;
            newState.isLoading = false;
            newState.error = action.error;
            return newState;

        case Constants.RESET_SINGLE_EMPLOYEE:
            var newState = { ...state };
            newState.employee = null;
            return newState;

        case Constants.SUCCESS_FILTER_EMPLOYEES:
            var newState = { ...state };
            newState.isPosting = false;
            newState.isLoading = false;
            newState.error = null;
            newState.isPosted = false;
            newState.filteredEmployees = action.payload;
            return newState;

        case Constants.REQUEST_UPDATE_EMPLOYEE_STATUS:
            newState = { ...state };
            newState.isLoading = true;
            newState.isPosted = false;
            newState.error = null;
            return newState;

        case Constants.SUCCESS_UPDATE_EMPLOYEE_STATUS:
            var newState = { ...state };
            newState.isPosting = false;
            newState.isLoading = false;
            newState.error = null;
            newState.isPosted = true;
            return newState;

        case Constants.FAILED_UPDATE_EMPLOYEE_STATUS:
            var newState = { ...state };
            newState.isLoading = false;
            newState.isPosting = false;
            newState.isPosted = false;
            newState.error = action.error;
            return newState;

        case Constants.RESET_EMPLOYEES:
            var newState = {
                ...state,
                currentEmployees: [],
                filteredEmployees: [],
                employee: null,
                isLoading: false,
                isPosting: false,
                isPosted: false,
                isDuplicateCode: false,
                count: 0,
                page: 1,
                pageSize: 10,
                error: null
            };
            return newState;
        default:
            return state;
    }
}


// WEBPACK FOOTER //
// ./src/reducers/EmployeeReducer.js